import React from "react";
import NavBar from "../components/NavBar";
import AboutUsPage from "../components/AboutUsPage";
import Footer from "../components/Footer";

const AboutUs = () => {
    return(
        <div>
            <NavBar/>
            <AboutUsPage/>
            <Footer/>
        </div>
    )
}

export default AboutUs;